import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import collectionRepository from '@/features/collections/repositories/CollectionRepository';
import pageRepository from '@/features/pages/repositories/PageRepository';
import type { Page } from '@/features/pages/types/page.types';
import { invalidateCollectionQueries, invalidatePageQueries } from '@/shared/query/queryKeys';

export function usePageCreateMutation() {
  const queryClient = useQueryClient();

  return useCallback(
    async (pageData?: Partial<Page>) => {
      try {
        const pageId = await pageRepository.addPage(pageData);

        if (pageData?.collectionId) {
          await collectionRepository.updateCollection(pageData.collectionId, {
            updatedAt: Date.now(),
          });
          void invalidateCollectionQueries(queryClient);
        }

        await invalidatePageQueries(queryClient);
        return pageId;
      } catch (error) {
        console.warn('Error adding page:', error);
        return undefined;
      }
    },
    [queryClient]
  );
}
